module.exports = __webpack_public_path__ + "img/blue_004.7c658496.png";